import { Fragment } from "react";
import Marquee from "react-marquee-slider";
import styled from "styled-components";
import times from "lodash/times";

const Photo = styled.img`
  width: ${(props) => 10240}px;
  height: ${(props) => 84}px;
  border-radius: 4px;
  box-shadow: 0 7px 20px 0 rgba(0, 0, 0, 0.12);
  object-fit: cover;
  object-position: top;
  margin-left: ${(props) => (props.offset === "true" ? props.scale * 7 : props.scale * 87)}px;
  margin-right: ${(props) => (props.offset === "true" ? props.scale * 80 : 0)}px;
`;

function Footer() {
	// let scale = 0.46;

  return (
    <Fragment>
		<div className="d-flex flex-column align-items-center shadow-lg p-2 mt-5 bg-white overflow-hidden">
			<h4><strong>PARTNERS</strong></h4>
			<div style={{ height: "84px" }}>
				<Marquee key='marque-l2382asd' velocity={25}>
				{times(5, Number).map((id) => (
					<Photo src="assets/images/partners.jpg" alt="" key={`partners-${id}`}  />
				))}
				</Marquee>
			</div>
		</div>
  		<footer id="footer">
			{/* <div className="footer-newsletter">
				<div className="container">
					<div className="row justify-content-center">
						<div className="col-lg-6">
							<h4>Join Our Newsletter</h4>
							<p>Tamen quem nulla quae legam multos aute sint culpa legam noster magna</p>
							<form action="" method="post">
								<input type="email" name="email"/>
								<input type="submit" value="Subscribe"/>
							</form>
						</div>
					</div>
				</div>
			</div> */}



			<div className="footer-top">
				<div className="container">
					<div className="row">
						<div className="col-lg-3 col-md-6 footer-contact">
							<h3>CONNECT</h3>
							<div className="social-links mt-3">
								{/* <a href="#" className="twitter"><i className="bx bxl-twitter"></i></a> */}
								<a href="http://www.facebook.com/WorldAquaCongress" target="_blank" rel="noreferrer" className="facebook"><i className="bx bxl-facebook"></i></a>
								{/* <a href="#" className="instagram"><i className="bx bxl-instagram"></i></a> */}
								{/* <a href="#" className="google-plus"><i className="bx bxl-skype"></i></a> */}
								{/* <a href="#" target="_blank" rel="noreferrer" className="linkedin"><i className="bx bxl-linkedin"></i></a> */}
							</div>
							<p>
								<strong>Praggya Sharmaa ( Ms )</strong><br/>
								Organising Secretary<br/>
								<strong>Mobiles:</strong><br/>
								+91-9818568825<br/>+91-9873556395<br/>
								<strong>Emails:</strong><br/>
								<a href="mailto:info@aquafoundation.in">info@aquafoundation.in</a><br/>
								<a href="mailto:wac@worldaquacongress.org">wac@worldaquacongress.org</a><br/>
							</p>
						</div>

						<div className="col-lg-3 col-md-6 footer-links">
							<h4>XVI WORLD AQUA CONGRESS</h4>
							<ul>
							<li><i className="bx bx-chevron-right"></i> <a href="/about-world-aqua-congress">About XVI World Aqua Congress</a></li>
							<li><i className="bx bx-chevron-right"></i> <a href="/about-aqua-foundation">About Aqua Foundation</a></li>
							</ul>
							<br/><br/>
							<h4>POLICIES</h4>
							<ul>
							<li><i className="bx bx-chevron-right"></i> <a href="/cancellation-and-refund-policy">Cancellation &amp; Refund-policy</a></li>
							<li><i className="bx bx-chevron-right"></i> <a href="/privacy-policy">Privacy Policy</a></li>
							<li><i className="bx bx-chevron-right"></i> <a href="/terms-and-conditions">Terms &amp; Conditions</a></li>
							</ul>
						</div>

						<div className="col-lg-3 col-md-6 footer-links">
							<h4>AQUA FOUNDATION'S EXCELLENCE AWARDS</h4>
							<ul>
								<li><i className="bx bx-chevron-right"></i> <a href="/aqua-foundations-excellence-awards">Awards 2024</a></li>
								<li><i className="bx bx-chevron-right"></i> <a href="https://www.waterawards.in/register.php" target="_blank" rel="noreferrer">Award Registration</a></li>
								<li><i className="bx bx-chevron-right"></i> <a href="https://www.waterawards.in/awards2020.php" target="_blank" rel="noreferrer">Award Recipients 2020</a></li>
								<li><i className="bx bx-chevron-right"></i> <a href="/awards-opportunities" target="_blank" rel="noreferrer">Awards Branding Opportunity</a></li>
								{/* <li><i className="bx bx-chevron-right"></i> <a href="#">Retrospective Glance</a></li> */}
							</ul>
							<br/>
							<h4>EXHIBITION</h4>
							<ul>
								<li><i className="bx bx-chevron-right"></i> <a href="/exhibition-opportunities">Exhibition Details</a></li>
							</ul>
						</div>

						<div className="col-lg-3 col-md-6 footer-links">
							<h4>REGISTRATION INFORMATION</h4>
							<ul>
								<li><i className="bx bx-chevron-right"></i> <a href="/registration-cost">Registration Cost</a></li>
								<li><i className="bx bx-chevron-right"></i> <a href="/register-as-delegate">Register as Delegate</a></li>
								<li><i className="bx bx-chevron-right"></i> <a href="/conference-abstract-information">Register as Author</a></li>
								{/* <li><i className="bx bx-chevron-right"></i> <a href="#">Quick Registrtaion</a></li> */}
							</ul>
							<br/><br/>
							<h4>CONFERENCE</h4>
							<ul>
								<li><i className="bx bx-chevron-right"></i> <a href="/conference-themes-and-topics">Themes and Topics</a></li>
								<li><i className="bx bx-chevron-right"></i> <a href="/conference-abstract-information">Abstract Information</a></li>
							</ul>
							
						</div>

					</div>
				</div>
			</div>

			<div className="container footer-bottom clearfix">
				<div className="copyright">
					&copy; Copyright <strong><span>Aqua Foundation</span></strong>. All Rights Reserved
				</div>
				<div className="credits">
					Powered by <a href="https://www.hummz.com/?utm_source=world-aqua-congress&utm_medium=web&utm_campaign=hummz-pages" target="_blank" rel="noreferrer">Hummz</a>
				</div>
			</div>
		</footer>
  		<button className="back-to-top"><i className="ri-arrow-up-line"></i></button>
  </Fragment>
  );
}

export default Footer;
